//import packages from node modules
import React, {useEffect, useRef, useCallback, useContext, useState} from 'react'
import {useDispatch,useSelector} from "react-redux";
import renderHTML from 'react-render-html'

//import utility functions
import {
  isHTML,
  LOCALE_STRING_OPTIONS,
  LOCALE_LANG_OPTIONS
} from "../../../../utilities/function/common";

import {
  getDataFromSuccessResponse,
  getErrorFromFailResponse
} from '../../../../utilities/function/apiResponse'

import {getAttributes} from "../../../../utilities/function/configuration"

import {getCycle,getPriceByBillingCycleName} from "../../../../utilities/function/billingCycle"

import {INIT, SelectHostingContext,UPDATE_ADDONS,UPDATE_CONFIG} from "../state";
import {getPID,getPromo} from "../index";
import {updateConfig} from "../../../../app/action";
import {MONTHLY} from "../../index";

//import shared components
import SelectHostingSlider from '../shared/slider'
import SolidButton from '../../../shared/button/solidbutton'
import PRODUCT_API from '../../../../utilities/api/product'
import Tooltip from "../../../shared/tooltip";

const initialConfigOption = {
  "Memory": 1,
  "CPU": 1,
  "Disk Space": 2
}
const Build = () => {
  const initFlag = useRef(false)
  const appDispatch = useDispatch()
  const {configurations} = useSelector(state=>({
    configurations: state.app.configurations
  }))
  const {state,dispatch} = useContext(SelectHostingContext)
  const initCallback = useCallback(()=>{
    if(!initFlag.current && !state.data){
      PRODUCT_API.getProduct([getPID(state)],getPromo(state)).then(successresponse => {
        const data = getDataFromSuccessResponse(successresponse)
        const getInitialConfig = ()=>{
          const config = []
          if(data && data.length && getAttributes(data[0])){
            const {config_options} = getAttributes(data[0])
            if(config_options && config_options.length){
              config_options.forEach((item,index)=> {
                const {id,options,name} = item
                const getSelectedOptionIndex = ()=>{
                  let index = 1
                  if(Object.keys(initialConfigOption) && Object.keys(initialConfigOption).length){
                    Object.keys(initialConfigOption).forEach((key)=>{
                      if(name=== key){
                        index = initialConfigOption[key]
                      }
                    });
                  }
                  return index
                }
                config[index] = {
                  config_id : id,
                  option_id: options[getSelectedOptionIndex()].id
                }
              })
            }
          }
          return config
        }
        const getInitialAddons = () => {
          const selectedAddons = []
          if(data && data.length && getAttributes(data[0])){
            const {addons,price} = getAttributes(data[0])
            if(addons && addons.length){
              const monthlyPrice = getPriceByBillingCycleName(price,MONTHLY)
              addons.forEach((item,index)=> {
                const {id} = item
                selectedAddons[index] = {
                  id,
                  biling_cycle_id: monthlyPrice.billing_cycle_id
                }
              })
            }
          }
          return selectedAddons
        }
        dispatch({
          type: INIT,
          data,
          config: getInitialConfig(),
          addons: getInitialAddons()
        })
      }, errorresponse => {
        const error = getErrorFromFailResponse(errorresponse)
        console.log(error)
      })
      initFlag.current = true
    }
  },[initFlag,dispatch,state])
  const [presetActive,setPresetActive] = useState(false)

  useEffect(()=>{
    initCallback()
  },[initCallback])

  const renderSliders = () => {
    const {data,config} = state
    if(data && data.length && getAttributes(data[0])){
      const {config_options} = getAttributes(data[0])
      if(config_options && config_options.length && config && config.length){
        return config_options.map((config_option,index)=>{
          const getOptionVal = () =>{
            let selectedIndex = 0
            const configItem = config.find(i=>i.config_id===config_option.id)
            if(config_option.options && config_option.options.length){
              config_option.options.forEach((option,index)=>{
                if(option.id===configItem.option_id){
                  selectedIndex = index
                }
              })
            }
            return selectedIndex
          }
          return (<SelectHostingSlider initialValue={getOptionVal()} key={index} item={config_option}/>)
        })
      }
    }
    return(<></>)
  }

  const getPriceList = (item) => {
    return item.discount_price ? item.discount_price : item.price
  }

  const renderPresets = () =>{
    const presetOnClick = () =>{
      setPresetActive(!presetActive)
    }
    if(state && state.presets){
      try{
        if(JSON.parse(state.presets)){
          const presets = JSON.parse(state.presets)
          const renderDropdown = () =>{
              return(
                <div className={`of-select-hosting-presets__dropdown${presetActive?' of-select-hosting-presets__dropdown--selected':''}`}>
                  <div className={`of-select-hosting-presets__dropdown-wrapper`} onClick={presetOnClick}>
                    <div className={'of-select-hosting-presets__dropdown-label'}>
                      See popular combinations
                    </div>
                    <div className={`of-select-hosting-presets__icon-wrapper`}>
                      <span className={`icon icon-of-arrow`} />
                    </div>
                  </div>
                </div>
              )
          }
          const renderList = () => {
            if(presetActive && presets && presets.length){
              const renderItem = () => {
                return presets.map((item,index)=>{
                  const {name,description,config,price} = item
                  const getCurrentConfigOptions = () => {
                    let selectedPresets = {}
                    if(state.data && state.data[0] && getAttributes(state.data[0])){
                      const {config_options} = getAttributes(state.data[0])
                      if(config_options && config_options.length){
                        if(Object.keys(config) && Object.keys(config).length){
                          selectedPresets = Object.keys(config).map(name=>{
                            const selectedConfig = config_options.find(i=>(i.name===name))
                            let selectedOption = null
                            if(selectedConfig && selectedConfig.options && selectedConfig.options.length){
                              selectedOption = selectedConfig.options.find(j=>(j.name===config[name]))
                              if(selectedOption){
                                return ({
                                  config_id: selectedConfig.id,
                                  option_id: selectedOption.id
                                })
                              }
                            }
                            return ({})
                          })
                        }
                      }
                    }
                    return selectedPresets
                  }

                  const presetItemOnClick = () => {
                    if(getCurrentConfigOptions()){
                      dispatch({
                        type: UPDATE_CONFIG,
                        config: getCurrentConfigOptions()
                      })
                    }
                  }


                  const isSelected = () => {
                    if(state && state.config && getCurrentConfigOptions()){
                      const selectedConfig = JSON.stringify(state.config)
                      const currentConfig = JSON.stringify(getCurrentConfigOptions())
                      if(selectedConfig===currentConfig){
                        return true
                      }
                      return false
                    }
                  }

                  return (
                        <div onClick={presetItemOnClick} key={index} className={`of-select-hosting-presets-item${isSelected()?' primary-border-1-100 primary-background-1-100 of-select-hosting-presets-item--selected':''}`}>
                          <div className={`of-select-hosting-presets-item__tooltip`}>
                            <Tooltip description={description} />
                          </div>
                          <div className={'of-select-hosting-presets-item__wrapper'}>
                            <div className={`of-select-hosting-presets-item__name text-font-1-100`}>
                              {name}
                            </div>
                            <div className={`of-select-hosting-presets-item__price text-font-3-100`}>
                              {price}
                            </div>
                          </div>
                        </div>
                    )
                })
              }
              return(
                  <div className={'of-select-hosting-presets__list'}>
                    {renderItem()}
                  </div>
              )
            }
            return (<></>)
          }

          return (
            <div className={'of-select-hosting-presets'}>
              {renderDropdown()}
              {renderList()}
            </div>
          )
        }
      } catch (e){
        console.log(e)
        return (<></>)
      }
    }
    return (<></>)
  }

  const renderTotal = ()=>{
    let total = 0
    let oldTotal = 0
    if(state && state.config && state.config.length && state.data && getAttributes(state.data[0])){
      const {config_options,addons} = getAttributes(state.data[0])
      const getConfigPrice = (config,base=false) =>{
        const {config_id,option_id} = config
        let subtotal = 0
        if(config_options && config_options.length){
          const selectedConfig = config_options.find(i=>i.id===config_id)
          if(selectedConfig && selectedConfig.options){
            const selectedOption = selectedConfig.options.find(i=>i.id===option_id)
            if(selectedOption && selectedOption.price){
              //set discount price if there is discount
              let priceList = getPriceList(selectedOption)
              let selectedPrice =  getPriceByBillingCycleName(priceList,'Monthly')
              //override base price if base equal true
              if(base){
                selectedPrice =  getPriceByBillingCycleName(selectedOption.price,'Monthly')
              }
              subtotal += selectedPrice? parseFloat(selectedPrice.price) : 0
            }
          }
        }
        return subtotal
      }
      const getSelectedAddonById = (id) =>{
        if(addons && addons.length){
          return addons.find(i=>i.id===id)
        }
        return undefined
      }
      const getAddonPrice = (addon,base = false) => {
        if(addon && getAttributes(addon) && getAttributes(addon).price){
          let priceList = getPriceList(getAttributes(addon))
          if(base){
            priceList = getAttributes(addon).price
          }
          const monthlyPrice = getPriceByBillingCycleName(priceList,MONTHLY)
          return parseFloat(monthlyPrice.price)
        }
      }

      //add config price
      state.config.forEach((config)=>{
        total += getConfigPrice(config)
        oldTotal += getConfigPrice(config,true)
      })

      //add addon price
      if(state.addons && state.addons.length){
        state.addons.forEach((addon)=>{
          const item = getSelectedAddonById(addon.id)
          if(item){
            total += getAddonPrice(item)
            oldTotal += getAddonPrice(item,true)
          }
        })
      }
    }
    if(total && typeof total.toLocaleString==="function"){
      const renderRight = () => {
        const renderPromo = () =>{
          if(state.promo){
            const getSave = () => {
              if(oldTotal && total){
                const save = ((parseFloat(oldTotal) - parseFloat(total)) / parseFloat(oldTotal)) * 100
                return Math.floor(save)
              }
              return 0
            }
            return (
                <div className={`of-select-hosting-build-total__promo`}>
                  <div className={`of-select-hosting-build-total__save`}>
                    Save {getSave()}%
                  </div>
                  <div className={`of-select-hosting-build-total__old-price text-font-3-100`}>${oldTotal.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}
                    {getCycle(MONTHLY)}</div>
                </div>
            )
          }
          return (<></>)
        }
        const renderTotalAmount = () => {
          return (
              <div className={`of-select-hosting-build-total__amount text-font-1-100`}>
                ${total.toLocaleString(LOCALE_LANG_OPTIONS,LOCALE_STRING_OPTIONS)}
                {getCycle(MONTHLY)}{state.promo?'*':''}
              </div>
          )
        }
        return (
          <div className={'of-select-hosting-build-total__right'}>
            {renderPromo()}
            {renderTotalAmount()}
          </div>
        )
      }
      return (
          <div className={'of-select-hosting-build__total of-select-hosting-build-total text-font-1-100'}>
            <div className={'of-select-hosting-build-total__label text-font-3-100'}>Total Cost</div>
            {renderRight()}
          </div>
      )
    }
    return (<></>)
  }

  const renderButton = () => {
    const buttonOnClick = (e) => {
      e.preventDefault()
      if(state){
        const {pid,router,data,promo} = state
        if(router){
          const {history} = router
          const selectedProduct = data[0]
          updateConfig(configurations,pid,{
            selectedProduct,
            config: state.config,
            addons: state.addons
          },appDispatch)
          history.push(`${history.location.pathname}?a=add&pid=${pid}&skipaddon=true${promo?'&promo='+ promo:''}`)
        }
      }
    }
    return (
        <SolidButton onClick={buttonOnClick} className={`of-select-hosting-build__button primary-background-2-100 text-font-1-100`}>Get Started</SolidButton>
    )
  }

  const renderAddons = () => {
    const {data,slide} = state
    if(data && data.length && getAttributes(data[0])){
      const {addons} = getAttributes(data[0])
      if(addons && addons.length){
        return addons.map((addon,index)=>{
          const {name,description,price} = getAttributes(addon)
          const isActive = () =>{
            let active = false
            if(state.addons && state.addons.length){
              active = state.addons.find(i=>i.id===addon.id)
            }
            return active
          }
          const renderMoreLink = () => {
            if(slide){
              const dom = document.getElementById(slide)
              if(dom){
                const readMoreOnClick = (e) => {
                  e.stopPropagation()
                  if(dom.getBoundingClientRect() && dom.getBoundingClientRect().top && window.scrollTo){
                    window.scrollTo({
                      top: dom.getBoundingClientRect().top + window.scrollY - 60,
                      behavior: 'smooth'
                    })
                  }
                }
                return (<div onClick={readMoreOnClick} className={'of-select-hosting-build-addon__read-more text-font-1-100'}>Read more</div>)
              }

            }
            return (<></>)
          }
          const renderDescription = () => {
            let striped = description
            if(description){
              striped =  description.replace(/(<([^>]+)>)/gi, "");
            }
            striped = striped.split(".")
            if(striped && Array.isArray(striped) && striped.length){
              return striped[0]+"."
            }
            return striped
          }
          const onActivate = () => {
            const monthlyPrice = getPriceByBillingCycleName(price,MONTHLY)
            let newAddons = []
            if(state.addons && state.addons.length && Array.isArray(state.addons)){
              newAddons = state.addons
              if(!state.addons.find(i=>i.id===addon.id)){
                newAddons.push({
                  id:addon.id,
                  billing_cycle_id: monthlyPrice.billing_cycle_id
                })
              }
            }else{
              newAddons = [{
                id: addon.id,
                billing_cycle_id: monthlyPrice.billing_cycle_id
              }]
            }
            dispatch({
              type: UPDATE_ADDONS,
              addons: newAddons
            })
          }
          const onDeactivate = () => {
            if(state && state.addons){
              const newaddons = state.addons.filter(i=>i.id!==addon.id)
              dispatch({
                type: UPDATE_ADDONS,
                addons: newaddons
              })
            }
          }
          const addonOnClick = () => {
            if(isActive()){
              onDeactivate()
            }else{
              onActivate()
            }
          }
          const getMonthlyPrice = () => {
            if(price && price.length){
              return <>
                <div className={'of-select-hosting-build-addon__price-value'}>${getPriceByBillingCycleName(price,MONTHLY).price}</div>
                <div className={'of-select-hosting-build-addon__price-cycle'}>{getCycle(MONTHLY)}</div>
              </>
            }
            return <></>
          }
          const renderTriangeleCss = () => {
           return "<style>.of-select-hosting-build-addon__triangle{ border-top-color: transparent !important;\n" +
                "    border-left-color: transparent !important;\n" +
                "    border-right-color: transparent !important; }</style>"
          }
          const renderRecommended = () => {
            if(isHTML(description)){
              return (
                  <div className={'of-select-hosting-build-addon__recommended status-background-3-100'}>

                    Recommended
                  </div>
              )
            }
            return (<></>)
          }
          return (
              <div key={index} className={`of-select-hosting-build-addon--${index} of-select-hosting-build-addon${isActive()?' of-select-hosting-build-addon--active primary-border-1-100':''}`} onClick={addonOnClick}>
                <div className={'of-select-hosting-build-addon__left'}>
                  <div className={'of-select-hosting-build-addon__wrapper'}>
                    <div className={'of-select-hosting-build-addon__name text-font-1-100'}>
                      <span>Add {name}</span>{renderRecommended()}
                    </div>
                    <div className={'of-select-hosting-build-addon__description text-font-3-100'}>{renderDescription()}{renderMoreLink()}</div>
                  </div>
                </div>
                <div className={'of-select-hosting-build-addon__right'}>
                  <div className={`of-select-hosting-build-addon__price ${isActive()?' primary-font-1-100':''}`}>{getMonthlyPrice()}</div>
                </div>
                <div className={`of-select-hosting-build-addon__triangle${isActive()?' primary-border-1-100':''}`}>
                  {renderHTML(renderTriangeleCss())}
                  <div className={`icon-of-tick-solid of-select-hosting-build-addon__tick`}></div>
                </div>
              </div>
          )
        })
      }
    }
    return (
        <></>
    )
  }

  return(
      <div className={'of-select-hosting-build of-select-hosting-page'}>
        {renderPresets()}
        {renderSliders()}
        {renderAddons()}
        {renderTotal()}
        {renderButton()}
      </div>
  )
}

export default Build